import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../Components/Public/Header";
import styles from "../HowWorks/HowWorks.module.scss";
import Image00 from "../../../Assets/images/image10.png";
import ImageCourse2 from "../../../Assets/images/course2.png";
import Image08 from "../../../Assets/images/image09.png";
import Image02Division02 from "../../../Assets/images/icon/image02.png";
import Image05Division02 from "../../../Assets/images/icon/image05.png";
import Image06Division02 from "../../../Assets/images/icon/image06.png";
import Image02 from "../../../Assets/images/image02.png";
import { Button } from "../../../Components/Button";
import "react-alice-carousel/lib/alice-carousel.css";
import { Footer } from "../../../Components/Public/Footer";
import { useTranslation } from "react-i18next";
import { SectionDivision03 } from "../../../Components/Public/SectionDivision03";
import { useLanguage } from "../../../contexts/LanguageContext";

export function HowWorks() {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const { selectedLanguage } = useLanguage();

  function handleRegist() {
    window.location.href = `${process.env.REACT_APP_NEXT_INTAKE_URL}/subscribe?lang=${selectedLanguage}`
    // navigate("/cadastre-se");
  }

  function handleWhatWeDo() {
    window.location.href = "/o-que-fazemos";
  }

  useEffect(() => {
    window.scroll(0, 1);
  }, []);

  return (
    <div id="page-top">
      <Header position={1} />
      <header className={`masthead ${styles.division01}`}>
        <div className={`container`}>
          <div className="row gx-5 align-items-center">
            <div className="col-lg-6">
              <div className="mb-5 mb-lg-0 text-center text-lg-start">
                <div className={`${styles.title01}`}>{t('Como_funciona.title1')}</div>
                <div className={`${styles.subTitle01}`}>
                  {t('Como_funciona.subtitle1')}
                </div>
                <div
                  className={`d-flex flex-lg-row align-items-center ${styles.btnDivision01} ${styles.deviceDivision01}`}
                >
                  <div onClick={handleRegist}>
                    <Button name={t('Como_funciona.button_cadastre_agora')} typeButton="primary" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="masthead-device-mockup">
              <iframe 
                width="560" 
                height="315" 
                src="https://www.youtube.com/embed/yzGx1TdinV4?si=O0HDU_3t5OOb0NTy&rel=0" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer;  dautoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowFullScreen 
              />
                {/* <img
                  src={Image00}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                /> */}
              </div>
            </div>
            <div
              className={`d-flex flex-lg-row mt-3 justify-content-center align-items-center ${styles.deviceDivision01_02}`}
            >
              <div className="m-2" onClick={handleRegist}>
                <Button name={t('Como_funciona.button_cadastre_agora')} typeButton="primary" />
              </div>
            </div>
          </div>
        </div>
      </header>
      <section className={styles.division02}>
        <div className={`container px-5`}>
          <div className="row gx-5 align-items-start">
            <div className={styles.title02}>{t('Como_funciona.title2')}</div>
            <div className="col-lg-3">
              <div className="mb-5 mb-lg-0 text-center text-lg-start flex-column align-items-center d-flex">
                <div
                  style={{ marginBottom: 15, marginTop: 40 }}
                  onClick={handleRegist}
                >
                  <Button name={t('Como_funciona.button_cadastre_agora')} typeButton="primary" />
                </div>
                <div className={styles.subText02}>{t('Como_funciona.indicator_1_Number')}</div>
                <div className={styles.Text01Division02}>
                  {t('Como_funciona.indicator_1_Description_1')}{" "}
                  <span className={styles.TextDefaultDivision02}>{t('Como_funciona.indicator_1_Description_2')}</span>
                </div>
                <div className={styles.TextDefaultDivision02}>{t('Como_funciona.indicator_1_Description_3')}</div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="mb-5 mb-lg-0 text-center text-lg-start flex-column align-items-center d-flex">
                <img
                  src={Image05Division02}
                  style={{ width: 96, height: 96 }}
                  alt="Imagem"
                />
                <div className={styles.subText02}>{t('Como_funciona.indicator_2_Number')}</div>
                <div className={styles.TextDefaultDivision02}>{t('Como_funciona.indicator_2_Description_1')}</div>
                <div className={styles.Text02Division02}>{t('Como_funciona.indicator_2_Description_2')}</div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="mb-5 mb-lg-0 text-center text-lg-start flex-column align-items-center d-flex">
                <img
                  src={Image06Division02}
                  style={{ width: 96, height: 96 }}
                  alt="Imagem"
                />
                <div className={styles.subText02}>{t('Como_funciona.indicator_3_Number')}</div>
                <div className={styles.TextDefaultDivision02}>
                  {t('Como_funciona.indicator_3_Description_1')}
                </div>
                <div className={styles.Text03Division02}>{t('Como_funciona.indicator_3_Description_2')}</div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="mb-5 mb-lg-0 text-center text-lg-start flex-column align-items-center d-flex">
                <img
                  src={Image02Division02}
                  style={{ width: 96, height: 96 }}
                  alt="Imagem"
                />
                <div className={styles.subText02}>{t('Como_funciona.indicator_4_Number')}</div>
                <div className="flex-row d-flex text-center">
                  <div className={styles.TextDefaultDivision02}>{t('Como_funciona.indicator_4_Description_1')}</div>
                  <div className={styles.Text04Division02}>{t('Como_funciona.indicator_4_Description_2')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SectionDivision03 i18nPrefix="Como_funciona" imageMain={Image08} imageCourse2={ImageCourse2} />
      {/* ************************************************************************* */}

      <section className={styles.division04}>
        <div className={`container px-5`}>
          <div className={`row gx-5 align-items-start`}>
            <div className={`col-lg-6 ${styles.deviceDivision04}`}>
              <div className="masthead-device-mockup">
                <img
                  src={Image02}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-lg-0 text-center text-lg-start">
                <div className={styles.title04}>
                  {t('Como_funciona.title4')}
                </div>
                <div className={styles.subTitle04}>
                  {t('Como_funciona.subtitle4')}
                </div>
                <div
                  className={`d-flex flex-column flex-lg-row align-items-center ${styles.btnDivision01} ${styles.deviceDivision01}`}
                >
                  <div
                    className="me-lg-3 mb-4 mb-lg-0"
                    onClick={handleWhatWeDo}
                  >
                    <Button
                      name={t('Como_funciona.button_o_que_fazemos')}
                      typeButton="secondary"
                      color="black"
                    />
                  </div>
                  <div onClick={handleRegist}>
                    <Button name={t('Como_funciona.button_cadastre_agora')} typeButton="primary" />
                  </div>
                </div>
              </div>
            </div>
            <div className={`col-lg-6 ${styles.deviceDivision04_01}`}>
              <div className="masthead-device-mockup">
                <img
                  src={Image02}
                  style={{ width: "100%", height: "100%" }}
                  alt="Imagem"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.division05}>
        <div className={`masthead ${styles.division05ColorTop}`}>
          <div className="container px-5">
            <div className={styles.title05}>
              {t('Como_funciona.title5')}
            </div>
            <div className={styles.subTitle05}>{t('Como_funciona.subtitle5')}</div>
            <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center">
              <div className="me-lg-3 mb-4 mb-lg-0" onClick={handleRegist}>
                <Button name={t('Como_funciona.button_cadastre_agora')} typeButton="primary" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
